import { TransitTimesAnalyticsActionTypes } from './constants';

type TransitTimesAnalyticsAction = { type: string, payload: {} | string };

export const transitTimesAnalyticsApiResponseSuccess = (actionType: string, data: any): TransitTimesAnalyticsAction => ({
    type: TransitTimesAnalyticsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const transitTimesAnalyticsApiResponseError = (actionType: string, error: string): TransitTimesAnalyticsAction => ({
    type: TransitTimesAnalyticsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const transitTimesAnalyticsGetAverageDomesticQuotedDays = (query: string): TransitTimesAnalyticsAction => ({
    type: TransitTimesAnalyticsActionTypes.GET_AVERAGE_DOMESTIC_QUOTED_DAYS,
    payload: { query },
});

export const transitTimesAnalyticsGetAverageDomesticActualDays = (query: string): TransitTimesAnalyticsAction => ({
    type: TransitTimesAnalyticsActionTypes.GET_AVERAGE_DOMESTIC_ACTUAL_DAYS,
    payload: { query },
});

export const transitTimesAnalyticsGetTransitTimesByServiceLevel = (query: string): TransitTimesAnalyticsAction => ({
    type: TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_BY_SERVICE_LEVEL,
    payload: { query },
});

export const transitTimesAnalyticsGetTransitTimesByTimeframe = (query: string): TransitTimesAnalyticsAction => ({
    type: TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_BY_TIMEFRAME,
    payload: { query },
});

export const transitTimesAnalyticsGetTransitTimesSummary = (query: string): TransitTimesAnalyticsAction => ({
    type: TransitTimesAnalyticsActionTypes.GET_TRANSIT_TIMES_SUMMARY,
    payload: { query },
});
